import { EnvironmentsIcon } from 'src/components/widgets/icons/scene';
import React, { FC, useState } from 'react';
import { T } from 'src/shared/helpers';
import { DuplicateIcon, PlusIcon, RenameIcon, TrashIcon, ViewGridIcon, ViewListIcon } from '../../../../../widgets/icons/scene';
import { ResourceListViewMode, ResourceListViewModeSwitch } from '../../../../../widgets/resourceList';
import { AssetEmptyState, AssetGrid } from './assetLibraryPanel';
import SectionPanel from './sectionPanel';
import { SceneEditorAction } from './sceneEditorActionBar';

// COME LE TEXTURE: c'è il guscio, non l'elenco. Qui però la ragione è più netta — **una
// libreria di ambienti non esiste proprio**. La scena tiene UN ambiente alla volta
// (`general.environmentTexture`, una URL) e uno skybox: due campi, non una collezione con
// nome, formato e risoluzione (docs/scene-editor-new-sections.md § 2).
//
// L'ambiente in uso si governa da **World → Environment map**, che quello lo sa fare
// davvero. Questa sezione diventerà la libreria da cui pescarlo.

const EnvironmentsEditor: FC = () => {
    const [viewMode, setViewMode] = useState<ResourceListViewMode>('cards');
    const [filter, setFilter] = useState('');

    const actions: SceneEditorAction[] = [
        {
            name: T._('Add environment', 'Admin'),
            tooltip: T._('Add an environment to the library', 'Admin'),
            icon: <PlusIcon />,
            kind: 'add',
            disabled: true,
            onClick: () => {}
        },
        { name: T._('Duplicate', 'Admin'), tooltip: T._('Duplicate', 'Admin'), icon: <DuplicateIcon />, disabled: true, onClick: () => {} },
        { name: T._('Rename', 'Admin'), tooltip: T._('Rename', 'Admin'), icon: <RenameIcon />, disabled: true, onClick: () => {} },
        { name: T._('Delete', 'Admin'), tooltip: T._('Delete', 'Admin'), icon: <TrashIcon />, kind: 'danger', disabled: true, onClick: () => {} }
    ];

    return (
        <SectionPanel
            label={T._('Environments library', 'Admin')}
            actions={actions}
            searchTrailing={
                <ResourceListViewModeSwitch
                    viewMode={viewMode}
                    viewModeLabel={T._('Environments view', 'Admin')}
                    cardsViewLabel={T._('Grid view', 'Admin')}
                    tableViewLabel={T._('List view', 'Admin')}
                    cardsIcon={<ViewGridIcon />}
                    tableIcon={<ViewListIcon />}
                    onViewModeChange={setViewMode}
                    tableFirst
                />
            }
            filter={filter}
            onFilterChange={setFilter}
            showUsageFilter
            searchPlaceholder={T._('Search environments...', 'Admin')}
        >
            <AssetGrid $list={viewMode === 'table'} />
            <AssetEmptyState icon={<EnvironmentsIcon />}>
                {T._('The scene holds one environment at a time. Set it in World → Environment map.', 'Admin')}
            </AssetEmptyState>
        </SectionPanel>
    );
};

export default EnvironmentsEditor;
